import React from 'react';
import { roundTo3Decimal} from '../../../../../../Utils';

const TotalRow = ({ days, data }) => {
    const style = { fontSize: '18px', fontWeight: 'bold' };
    const valuesTd = days.reduce((arr, day) => {
        const dayData = data[day];

        let spends = 0, conversions = 0, eCost = 0;

        if(dayData) {
            spends = roundTo3Decimal(dayData.spends);
            conversions = dayData.conversions;
            eCost = roundTo3Decimal(dayData.eCost);
        }

        arr.push(<td style={style} key={`${day}_spends`}>{spends}</td>);
        arr.push(<td style={style} key={`${day}_conversions`}>{conversions}</td>);
        arr.push(<td style={style} key={`${day}_eCost`}>{eCost}</td>);

        return arr;
    }, []);

    return (
        <tr>
            <td colSpan={4}>Total</td>
            {valuesTd}
        </tr>
    );
};

export default TotalRow;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/DaysTable/components/TotalRow/index.js